import React, { useEffect, useState } from "react";
import { useTonWallet } from "@tonconnect/ui-react";

import MainButton from "../components/MainButton";
import FriendsGroupIcon from "../assets/icons/friends-group-icon.svg";
import SellTicketIcon from "../assets/icons/ticket-pink-icon.svg";
import RefsGroupIcon from "../assets/icons/ref-group.svg";

import {
  getPlayerBasicInfo,
  getPlayerReferrer,
  PlayerBasicInfoDTO,
} from "../blockchain/lotteryClient";

function Friends() {
  const wallet = useTonWallet();
  const address = wallet?.account.address;

  const [player, setPlayer] = useState<PlayerBasicInfoDTO | null>(null);
  const [referrer, setReferrer] = useState<string | null>(null);

  useEffect(() => {
    if (!address) {
      setReferrer(null);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const ref = await getPlayerReferrer(address);

        if (!cancelled) {
          setReferrer(ref); // string | null
        }
      } catch {
        if (!cancelled) {
          setReferrer(null);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [address]);


  const shortAddress = address
    ? `${address.slice(0, 6)}…${address.slice(-4)}`
    : "-";

  const myFriends = player?.referredCount ?? 0;
  const soldTickets = player?.ticketsSoldByReferrals ?? 0;

  const referralIncome = Number(player?.referralBonus ?? 0n) / 1e9;
  const soldIncome = Number(player?.soldBonus ?? 0n) / 1e9;
  const totalIncome = referralIncome + soldIncome;

  const handleOpenShareModal = () => {
    if (!address) return;

    const link = `https://your-site.app/?ref=${address}`;
    const text = `Привет! Присоединяйся по моей реферальной ссылке 👇`;

    const telegramLink =
      `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;

    window.open(telegramLink, "_blank");
  };

  return (
    <div className="friends">
      <div className="friends_header">
        <span className="friends_header_title">Реферальная программа</span>
        <div className="friends_header__content">
          Приглашайте друзей и зарабатывайте на их покупках билетов.
        </div>
      </div>

      <div className="friends_identifier">
        <div className="friends_identifier__title">Ваш идентификатор</div>
        <div className="friends_identifier__content">
          <span>{shortAddress}</span>
        </div>
      </div>

      <MainButton
        text="Поделиться моей ссылкой"
        func={handleOpenShareModal}
      />

      <div className="friends_friends-group">
        <div className="friends_friends-group__title">Друзья</div>

        <div className="friends_friends-group__item">
          <div className="friends_friends-group__item___info">
            <img src={FriendsGroupIcon} alt="" width={32} height={32} />
            <span>Мои друзья</span>
          </div>
          <div className="friends_friends-group__item___count">
            {myFriends}
          </div>
        </div>
      </div>

      <div className="friends_friends-group">
        <div className="friends_friends-group__title flex-style">
          <span>Заработок от друзей</span>
          <span>$ {totalIncome.toFixed(2)}</span>
        </div>

        <div className="friends_friends-group__item">
          <div className="friends_friends-group__item___info">
            <img src={RefsGroupIcon} alt="" width={32} height={32} />
            <div>
              <span>Привлечь рефералов</span>
              <div className="friends-card-subtitle">+5% от покупки</div>
            </div>
          </div>
          <div className="friends_friends-group__item___count">
            {myFriends}
          </div>
        </div>

        <div className="friends_friends-group__item">
          <div className="friends_friends-group__item___info">
            <img src={SellTicketIcon} alt="" width={32} height={32} />
            <div>
              <span>Продать билетов</span>
              <div className="friends-card-subtitle">10% от суммы покупки</div>
            </div>
          </div>
          <div className="friends_friends-group__item___count">
            {soldTickets}
          </div>
        </div>
      </div>

      <div className="friends_identifier">
        <div className="friends_identifier__title">Ваш пригласитель</div>
        <div className="friends_identifier__content">
          <span>{referrer ?? "-"}</span>
        </div>
      </div>
    </div>
  );
}

export default Friends;
